const initialState = {
  subCategoryList: []
};

export const subCategoryReducer = (state = initialState, action) => {
  if (typeof action.execute === "function" && action.type === "sub_categories")
    return action.execute(state);
  return state;
};
